import { render, staticRenderFns } from "./FillClaimCreation.vue?vue&type=template&id=ba48cb8e&scoped=true"
import script from "./FillClaimCreation.vue?vue&type=script&lang=js"
export * from "./FillClaimCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba48cb8e",
  null
  
)

export default component.exports